// @flow strict
import * as React from "react";
import { imgSrc } from "~common/utils";
import styles from "./Frame.module.css";
import type { Store } from "~robin-hood/redux/store";
import classnames from "~common/classnames";

type Props = {
  children: React$Node,
  store: Store,
  updateStore: (Store) => void,
};

export function Frame(props: Props): React$Node {
  return <div className={styles.Frame}>{props.children}</div>;
}

type InFrameProps = {
  children: React$Node,
  className?: string,
  style?: $FlowFixMeObjectType,
  noToolbar?: boolean,
};

const BACKGROUND_WINDOWS = {
  // backgroundImage: imgSrc("/images/robin-hood/desktop.png"),
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};

export function InFrame(props: InFrameProps): React$Node {
  return (
    <div
      className={classnames(
        props.className,
        styles.InFrame,
        !props.noToolbar && styles.withToolbar
      )}
      style={props.style ? props.style : BACKGROUND_WINDOWS}
    >
      {props.children}
    </div>
  );
}
